<template>
  <div>
    <v-navigation-drawer
      app
      permanent
      clipped
      width="200"
    >
      <v-divider />
      <v-list>
        <v-list-tile v-for="page in pages" :key="page.text" :to="page.path">
          <v-list-tile-action>
            <v-icon>{{ page.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ page.text }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-container>
      <router-view />
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    pages: [
      { text: 'Properties', path: '/owner/properties', icon: 'location_city' },
      { text: 'Accounting', path: '/owner/accounting', icon: 'pie_chart' },
      { text: 'Account', path: '/owner/details', icon: 'person' },
      { text: 'Contact', path: '/owner/contact', icon: 'email' },
    ],
  }),
};
</script>

<style></style>
